module.exports = __webpack_public_path__ + "img/woman-evening.b2b72636.png";